import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {BucketModel} from '@features/transaction-tracker/models/transaction-tracker.model';
import {sign} from 'crypto';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-platform-tool-bucket-folder-view',
  templateUrl: './platform-tool-bucket-folder-view.component.html',
  styleUrls: ['./platform-tool-bucket-folder-view.component.scss']
})
export class PlatformToolBucketFolderViewComponent implements OnInit, IPlatformToolComponent, OnDestroy {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  buckets: BucketModel[] = [];
  private unsubscribe$ = new Subject<void>();
  constructor(private platformQueryService: PlatformQueryService) { }

  ngOnInit(): void {
    const query = this.selectedTab.tabData['GetBucketQuery'] as PlatformQuery;
    this.invalidateSubject.getObservale().pipe(takeUntil(this.unsubscribe$)).subscribe(signature => {
      if (signature === 'BucketsCategory') {
        this.getBucketFolders(query);
      }
    });
    this.getBucketFolders(query);
  }

  private getBucketFolders(query: PlatformQuery) {
    this.platformQueryService.executeQuery(query).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      this.buckets = res.fieldValues['Buckets'];
      this.invalidateSubject.invalidate();
    });
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

  onClickAddBucket() {
    const command = this.magicLinkModel.additionalCommands['AddBucketCategoryCommand'];
    this.handler.executeCommand(command);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onClickBucket(bucket: BucketModel) {
    const command = this.magicLinkModel.additionalCommands['TabViewCommand'];
    command.fieldValues['SelectedTabId'] = bucket.id;
    this.handler.executeCommand(command);
  }
}
